import { TableColumn } from '@column/column-ui-kit';

export const getColumnVisibility = <T>(columns: TableColumn<T>[], visibleColumns: string[] | undefined) => {
  return columns.reduce(
    (acc, column) => {
      acc[column.accessor as string] = visibleColumns?.includes(column.accessor as string) ?? true;
      return acc;
    },
    {} as Record<string, boolean>
  );
};
